import {
  AuthSettings,
  GlobalConfig as GlobalConfigValues
} from 'services/api-service'

// AuthSettings values
// question: 1 - anon, 2 - name & email req, 3 - confirm req
// answer & reply: 1 - name & email req, 2 - confirm req
// review: 1 - name & email req, 3 - confirm req, 4 - purchase req

type UgcType = 'question' | 'answer' | 'reply' | 'review'

export interface IGlobalConfig extends GlobalConfigValues {
  isAllowAnon(): boolean
  isConfirmReq(ugcType: UgcType): boolean
  isPurchaseReq(): boolean
}

export class GlobalConfig implements IGlobalConfig {
  constructor(config: IGlobalConfig) {
    this.additionalPagingScroll = config.additionalPagingScroll
    this.authSettings = config.authSettings
    this.mediaEnabled = config.mediaEnabled
    this.modalHeadingLevel = config.modalHeadingLevel || 2
    this.multiItemAnswerEnabled = config.multiItemAnswerEnabled
    this.multiItemPickerTitleLength = config.multiItemPickerTitleLength
    this.siteName = config.siteName
    this.ssoEnabled = config.ssoEnabled
  }

  additionalPagingScroll: number // number of additional pixels to scroll up after paging (TT-11682)
  authSettings: AuthSettings
  mediaEnabled: boolean
  modalHeadingLevel: number
  multiItemAnswerEnabled: boolean
  multiItemPickerTitleLength: number
  siteName: string
  ssoEnabled: boolean

  isAllowAnon() {
    return this.authSettings.question === 1
  }
  isConfirmReq(ugcType: UgcType) {
    if (ugcType === 'question' && this.authSettings.question === 3) {
      return true
    } else if (['answer', 'reply'].indexOf(ugcType) > -1 && this.authSettings.answerReply === 2) {
      return true
    } else if (ugcType === 'review' && this.authSettings.review === 3) {
      return true
    }
    return false
  }
  isPurchaseReq() {
    return this.authSettings.review === 4
  }
}

let defaultConfig: IGlobalConfig
export function loadConfig(config: IGlobalConfig) {
  defaultConfig = new GlobalConfig(config)
}
export { defaultConfig as default }
